import ContentObject from "./ContentObject";
import ContentTile from "./ContentTile";
import Season from "./Season";
import ProgressBar from "./ProgressBar";
import {titleFromOptions} from "../web/v2/featured_content";
import $ from "jquery";
import Purchase from "./Purchase";
import {startModalAutoPlay, stopAllAutoPlay} from "../web/v2/preview_autoplay"

export default class ObjectDetail {
    constructor( data, elements, constants ) {
        this.elements = elements;
        this.content_object = new ContentObject( data, constants );
    }

    display() {
        this.setMainDetails()
        this.checkButtons();
        this.checkTabs();
    }

    populateTabs() {
        this.addEpisodes();
        this.addSuggestions();
        this.checkExtras();
        this.addDetails();
        this.purchaseConfirmation();
    }

    setupAutoPlayPreview() {
        stopAllAutoPlay();
        this.initAutoplayPreview();
    }

    initAutoplayPreview() {
        let previewUrl = this.content_object.previewUrl();
        if (previewUrl) {
            stopAllAutoPlay();
            startModalAutoPlay(previewUrl);
        }
    }

    setMainDetails() {
        this.setScreenshot();
        this.setName();
        this.setProgress()
        this.setDuration();
        this.setSeasons();
        this.setImdb();
        this.setContentRating();
        this.setTags();
        this.setEpisode();
        this.setDescription();
    }

    setScreenshot() {
        this.setElSrcFromObj( '', this.elements.screenshot );
        if ( this.content_object.displayScreenshot() ) {
            this.setElSrcFromObj( this.content_object.screenshot(), this.elements.screenshot );
        }
    }

    setName() {
        $( this.elements.details.name ).hide();
        this.setElHTMLFromObj('', this.elements.details.name);
        if ( this.content_object.name() ) {
            this.setElHTMLFromObj( this.nameFromContentObject(), this.elements.details.name );
            $( this.elements.details.name ).show();
        }
    }

    nameFromContentObject() {
        let options = {
            name: this.content_object.name(),
            title_image_url: this.content_object.titleImageUrl(),
            featured: false
        };

        return titleFromOptions(options);
    }

    setProgress() {
        $( this.elements.details.progress ).html( '' );
        if ( this.content_object.displayResume() ) {
            let object = ( this.content_object.isMovie() ? this.content_object : this.content_object.episode );
            let duration = object.duration();
            let resume_time = object.resumeTime();
            let progress = new ProgressBar( duration, resume_time );
            let progress_bar = progress.element();
            if ( progress_bar ) {
                $( this.elements.details.progress ).append( progress_bar );
            }
        }
    }

    setDuration() {
        $( this.elements.details.duration ).hide();
        this.setElHTMLFromObj('', this.elements.details.duration);
        if ( this.content_object.displayDuration() ) {
            this.setElHTMLFromObj( this.content_object.duration(), this.elements.details.duration);
            $( this.elements.details.duration ).show();
        }
    }

    setSeasons() {
        $( this.elements.details.seasons ).hide();
        this.setElHTMLFromObj('', this.elements.details.seasons);
        if ( this.content_object.displaySeasons() ) {
            this.setElHTMLFromObj( this.content_object.seasonCount(), this.elements.details.seasons );
            $( this.elements.details.seasons ).show();
        }
    }

    setImdb() {
        $( this.elements.details.imdb ).hide();
        this.setElHTMLFromObj('', this.elements.details.imdb_rating);
        this.setElHTMLFromObj('', this.elements.details.imdb_votes);
        if ( this.content_object.displayImdb() ) {
            this.setElHTMLFromObj( this.content_object.imdbRating(), this.elements.details.imdb_rating );
            this.setElHTMLFromObj( this.content_object.imdbVotes(), this.elements.details.imdb_votes );
            $( this.elements.details.imdb ).show();
        }
    }

    setContentRating() {
        $( this.elements.details.content_rating ).hide();
        this.setElHTMLFromObj( '', this.elements.details.content_rating_text );
        if ( this.content_object.contentRating() ) {
            this.setElHTMLFromObj( this.content_object.contentRating(), this.elements.details.content_rating_text );
            $( this.elements.details.content_rating ).show();
        }
    }

    setTags() {
        this.setElHTMLFromObj( '', this.elements.details.tags );
        if ( this.content_object.displayTags() ) {
            this.setElHTMLFromObj( this.content_object.tags(), this.elements.details.tags );
        }
    }

    setEpisode() {
        $( this.elements.sections.episode_details ).hide();
        this.setElHTMLFromObj('', this.elements.episode.name );
        this.setElHTMLFromObj( '', this.elements.episode.description );
        if ( this.content_object.hasEpisode() ) {
            this.setElHTMLFromObj( this.content_object.episodeName(), this.elements.episode.name );
            if ( this.content_object.displayEpisodeDescription() ) {
                this.setElHTMLFromObj( this.content_object.description(), this.elements.episode.description );
            }

            $( this.elements.details.movie.description.container ).hide();
            $( this.elements.sections.episode_details ).show();
        }
    }

    setDescription() {
        $( this.elements.details.movie.description.container ).hide();
        this.setElHTMLFromObj( '', this.elements.details.movie.description );
        if ( this.content_object.displayMovieDescription() ) {
            this.setElHTMLFromObj( this.content_object.description(), this.elements.details.movie.description );
            $( this.elements.sections.episode_details ).hide();
            $( this.elements.details.movie.description.container ).show();
        }
    }

    resetActionButtons() {
        let action_buttons = Object.values( this.elements.actions.button );
        $.each( action_buttons, function( index, button ) {
            $( button ).attr( 'href', 'javascript: void(0);' );
            $( button ).hide();
        });

    }

    checkTVOD() {
        $( this.elements.actions.span.rent_amount ).html( '' );
        $( this.elements.actions.span.buy_amount ).html( '' );
        $( this.elements.actions.button.rent ).data( 'id', '' );
        $( this.elements.actions.button.rent ).data( 'kind', '' );

        if ( this.content_object.displayTVOD() ) {
            if ( this.content_object.isTVODRent() ) {
                $( this.elements.actions.span.rent_amount ).html( this.content_object.tvodRentAmount() );
                $( this.elements.actions.button.rent ).data( 'id', this.content_object.id() );
                $( this.elements.actions.button.rent ).data( 'kind', this.content_object.kind() );
                $( this.elements.actions.button.rent ).show();
            }

            if ( this.content_object.isTVODBuy() ) {
                $( this.elements.actions.span.buy_amount ).html( this.content_object.tvodBuyAmount() );
                $( this.elements.actions.button.buy ).data( 'id', this.content_object.id() );
                $( this.elements.actions.button.buy ).data( 'kind', this.content_object.kind() );
                $( this.elements.actions.button.buy ).show();
            }
        }
    }

    checkPlayOptions() {
        if ( this.content_object.displayWatch() ) {
            $( this.elements.actions.button.play ).removeClass( 'play-secondary' );

            if ( this.content_object.displayResume() ) {
                $( this.elements.actions.button.resume ).attr( 'href', this.content_object.resumeButtonHref() );
                $( this.elements.actions.button.resume ).show();

                $( this.elements.actions.button.play ).addClass( 'play-secondary' );
            }

            $( this.elements.actions.span.play ).html( this.content_object.playButtonText() );
            $( this.elements.actions.button.play ).attr( 'href', this.content_object.playButtonHref() );
            $( this.elements.actions.button.play ).show();
        }
    }

    checkTrailer() {
        if ( this.content_object.displayTrailer() ) {
            $( this.elements.actions.button.trailer ).attr( 'href', this.content_object.trailer() );
            $( this.elements.actions.button.trailer ).show();
        }
    }

    checkWatchListOptions() {
        let $watchlist_add = $( this.elements.actions.button.watchlist_add );
        let $watchlist_remove = $( this.elements.actions.button.watchlist_remove );

        $watchlist_add.hide();
        $watchlist_add.data( 'slug', this.content_object.slug() );

        $watchlist_remove.hide();
        $watchlist_remove.data( 'slug', this.content_object.slug() );

        if ( this.content_object.displaySignedInUserActions() ) {
            if ( this.content_object.onWatchlist() ) {
                $watchlist_remove.show();
            } else {
                $watchlist_add.show();
            }
        }
    }

    checkThumbs() {
        let $thumbs_up = $( this.elements.actions.button.thumbs_up );
        let $thumbs_down = $( this.elements.actions.button.thumbs_down );

        $thumbs_up.hide();
        $thumbs_up.data( 'url', this.content_object.thumbsUpUrl() );
        $thumbs_up.removeClass('active');

        $thumbs_down.hide();
        $thumbs_down.data( 'url', this.content_object.thumbsDownUrl() );
        $thumbs_down.removeClass('active');

        if ( this.content_object.displaySignedInUserActions() ) {
            $thumbs_up.show();
            $thumbs_down.show();
            if ( !this.content_object.noThumbs() ) {
                if ( this.content_object.liked() ) {
                    $thumbs_up.addClass('active');
                } else {
                    $thumbs_down.addClass('active');
                }
            }
        }
    }

    checkButtons() {
        this.resetActionButtons();
        this.checkTVOD();
        this.checkPlayOptions();
        this.checkTrailer();
        this.checkWatchListOptions();
        this.checkThumbs();
    }

    resetTabs() {
        $( this.elements.tabs.links.episodes ).removeClass('active');
        $( this.elements.tabs.links.suggested ).removeClass('active');
        $( this.elements.tabs.links.extras ).removeClass('active');
        $( this.elements.tabs.links.details ).removeClass('active');

        $( this.elements.tabs.content.episodes ).removeClass('active');
        $( this.elements.tabs.content.suggested ).removeClass('active');
        $( this.elements.tabs.content.extras ).removeClass('active');
        $( this.elements.tabs.content.details ).removeClass('active');

        $( this.elements.tabs.content.episodes ).removeClass('show');
        $( this.elements.tabs.content.suggested ).removeClass('show');
        $( this.elements.tabs.content.extras ).removeClass('show');
        $( this.elements.tabs.content.details ).removeClass('show');
    }

    toggleTabs() {
        if ( this.content_object.isMovie() ) {
            $( this.elements.tabs.toggleable.episodes ).hide();

            if ( this.content_object.displayExtras() ) {
                this.prepareTab( this.elements.tabs.links.extras, this.elements.tabs.content.extras );
            } else {
                this.prepareTab( this.elements.tabs.links.suggested, this.elements.tabs.content.suggested );
            }
        } else {
            this.prepareTab( this.elements.tabs.links.episodes, this.elements.tabs.content.episodes, this.elements.tabs.toggleable.episodes );
        }
    }

    prepareTab(link, content, toggleable=null) {
        if ( toggleable ) {
            $( toggleable ).show();
        }

        let $content = $( content );
        if ( $content ) {
            $content.addClass('show');
            $content.addClass('active');
        }

        let $link = $( link );
        if ( $link ) {
            $link.click();
        }
    }

    checkTabs() {
        this.resetTabs();
        this.toggleTabs();
    }

    addEpisodes() {
        let $episodes = $( this.elements.tabs.content.episodes );
        $episodes.hide();
        $episodes.html('');
        if ( this.content_object.displayEpisodes() ) {
            let season = new Season( this.content_object, );
            $episodes.append( season.element() );
        }

        $episodes.show();
    }

    addSuggestions() {
        let $suggested = $( this.elements.tabs.container.suggested );
        $suggested.html('');
        $suggested.hide();

        if ( this.content_object.displaySuggestions() ) {
            let suggestions = this.content_object.suggestions();
            for( let i= 0; i < 10; i++) {
                if ( suggestions[i] ) {
                    let content_tile = new ContentTile( suggestions[i], [ 'col', 'mb-2', 'mb-md-5' ] );
                    $suggested.append( content_tile.element() );
                }
            }

            $suggested.show();
        }
    }

    checkExtras() {
        let $extras_link = $( this.elements.tabs.links.extras );
        $extras_link.hide();

        let $extras_content = $( this.elements.tabs.content.extras );
        $extras_content.hide();

        $( this.elements.tabs.extras.containers ).hide();

        let $quiz_link = $( this.elements.tabs.extras.quiz );
        $quiz_link.hide();
        $quiz_link.parent().hide();

        let $activity_book_link = $( this.elements.tabs.extras.activity_book );
        $activity_book_link.hide();
        $activity_book_link.parent().hide();

        let $lesson_link = $( this.elements.tabs.extras.lesson.link );
        $lesson_link.hide();
        $lesson_link.parent().hide();

        let $lesson_title = $( this.elements.tabs.extras.lesson.title );
        $lesson_title.html('');

        let $lesson_description = $( this.elements.tabs.extras.lesson.description );
        $lesson_description.html('');

        $( this.elements.tabs.extras.links ).attr( 'href', this.content_object.constants.path.void );

        let content_object = this.content_object.hasEpisode() ? this.content_object.episode : this.content_object
        if ( content_object.displayExtras() ) {
            let $quiz = $( this.elements.tabs.extras.quiz );
            let $activity_book = $( this.elements.tabs.extras.activity_book );
            let $lesson = $( this.elements.tabs.extras.lesson.link );

            if ( content_object.displayQuiz() && $quiz) {
                $quiz.attr( 'href', content_object.quizHref() );
                $quiz.parent().show();
                $quiz_link.parent().show();
                $quiz_link.show();
            }

            if ( content_object.activityBookHref() && $activity_book ) {

                $activity_book.attr( 'href', content_object.activityBookHref() );
                $activity_book.parent().show();
                $activity_book_link.parent().show();
                $activity_book_link.show();
            }

            if ( content_object.displayLesson() && $lesson ) {
                $lesson.attr( 'href', content_object.lessonHref() );
                $lesson_title.html( content_object.lessonTitle() );
                $lesson_description.html( content_object.lessonDescription() );
                $lesson.parent().show();
                $lesson_link.parent().show();
                $lesson_link.show();
            }

            $extras_link.show();
            $extras_content.show();
        }
    }

    addDetails() {
        let $details_link = $( this.elements.tabs.links.details );
        $details_link.hide();

        let $details_content = $( this.elements.tabs.content.details );
        $details_content.hide();
    }

    purchaseConfirmation() {
        $( this.elements.tvod_content ).html( '' );
        if ( this.content_object.displayTVOD() ) {
            const template = document.querySelector('#tvod_purchase_template');
            let modal_body = new Purchase( this.content_object, template );
            let tvod = modal_body.element();
            if ( tvod ) {
                $( this.elements.tvod_content ).append( tvod );
            }
        }
    }

    setElHTMLFromObj(val, el) {
        let $el = $(el);
        if ( $el ) {
            $el.html(val);
        }
    }

    setElSrcFromObj(src, el) {
        let $el = $(el);
        if ( $el && src ) {
            $el.attr('src', src);
        }
    }
}